import { createActions, createReducer } from 'reduxsauce'

import ConsultaConveniosInstrumentosCongeneresService from '../../servicos/ConsultaConveniosInstrumentosCongeneresService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaConveniosInstrumentosCongeneresInicio: [],
    buscaConsultaConveniosInstrumentosCongeneresErro: ['erro'],
    buscaConsultaConveniosInstrumentosCongeneresSucesso: ['consultaConveniosInstrumentosCongeneres'],
    limpar: [],
    setConsultaConveniosInstrumentosCongeneresEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaConveniosInstrumentosCongeneres = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaConveniosInstrumentosCongeneresInicio())
        let serv = new ConsultaConveniosInstrumentosCongeneresService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaConsultaConveniosInstrumentosCongeneresSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaConveniosInstrumentosCongeneresErro(error)))
    }
}

const buscaConsultaConveniosInstrumentosCongeneresInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaConveniosInstrumentosCongeneresErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaConsultaConveniosInstrumentosCongeneresSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaConveniosInstrumentosCongeneres.resultado,
        dataSincronizacaoDados: action.consultaConveniosInstrumentosCongeneres.dataSincronizacaoDados,
        fonte: action.consultaConveniosInstrumentosCongeneres.fonte,
        carregando: false,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaConveniosInstrumentosCongeneresEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES_INICIO]: buscaConsultaConveniosInstrumentosCongeneresInicio,
    [Types.BUSCA_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES_ERRO]: buscaConsultaConveniosInstrumentosCongeneresErro,
    [Types.BUSCA_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES_SUCESSO]: buscaConsultaConveniosInstrumentosCongeneresSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_CONVENIOS_INSTRUMENTOS_CONGENERES_ESTADO_DT]: setConsultaConveniosInstrumentosCongeneresEstadoDT,
})
